interface TableWrapperProps {
    title: string
    children: React.ReactNode
}

export const TableWrapper: React.FC<TableWrapperProps> = ({ title, children }) => {
    return (
        <>
            <div className="mt-4 tableTitle">{title}</div>
            <div className="tableContainer">{children}</div>
        </>
    )
}